import type { RouteRecordRaw } from 'vue-router';

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/components/views/admin/Login.vue'),
    meta: { title: '管理者ログイン' },
  },
  {
    path: '/admin',
    component: () => import('@/components/layouts/admin/AdminLayout.vue'),
    meta: { requiresAdminAuth: true },
    children: [
      {
        path: '',
        name: 'AdminDashboard',
        component: () => import('@/components/views/admin/Dashboard.vue'),
        meta: { title: '管理者ダッシュボード' },
      },
      {
        path: 'clinics',
        name: 'AdminClinicList',
        component: () => import('@/components/views/admin/ClinicList.vue'),
        meta: { title: '病院管理' },
      },
      // AI-WF#185: 全テナント共通の振込口座画面は廃止（病院単位に移行）。コメント化して無効化。
      //   病院ごとの口座は「病院管理(ClinicList)」内の口座編集 or clinic 側「設定→振込口座」で行う。
      // {
      //   path: 'bank-account',
      //   name: 'AdminBankAccount',
      //   component: () => import('@/components/views/admin/BankAccount.vue'),
      //   meta: { title: '入金情報設定' },
      // },
      {
        path: 'tax-rate',
        name: 'AdminTaxRate',
        component: () => import('@/components/views/admin/TaxRate.vue'),
        meta: { title: '消費税設定' },
      },
    ],
  },
];
